import React from "react";
import moment from "moment";
import { Grid, Row, Col } from 'armstrong-react-fix';
import { toMoment, createDateFromParts, getDayOfMonth, getMonth, getYear, isSame } from '@travellocal/utils/dateHelpers';

interface Props extends React.Props<DatePicker> {
  date?: IDate;
  onChange?: (date: IDate) => void;
  yearsFromNow?: number;
  futureDates?: boolean;
}

interface LocalState {
  day?: number;
  month?: number;
  year?: number;
  date?: IDate;
}

export class DatePicker extends React.Component<Props, LocalState> {
  constructor(props: Props) {
    super(props);
    this.state = { day: null, month: null, year: null, date: null };
  }
  getDaysArrayByMonth(): string[] {
    let activeMoment = this.state.date ? toMoment(this.state.date) : moment();
    if (this.state.month) {
      activeMoment.set("month", this.state.month - 1)
    }
    let daysInMonth = activeMoment.daysInMonth();
    let arrDays = [];

    for (var d = 1; d < daysInMonth + 1; d++) {
      arrDays.push(d.toString());
    }
    return arrDays;
  }
  dayChanged(day: string) {
    this.setState({ day: parseInt(day) }, () => {
      this.buildDate();
    });
  }
  monthChanged(month: string) {
    this.setState({ month: parseInt(month) }, () => {
      this.buildDate();
    });
  }
  yearChanged(year: string) {
    this.setState({ year: parseInt(year) }, () => {
      this.buildDate();
    });
  }
  componentWillMount() {
    if (this.props.date) {
      let d = this.props.date;
      this.setState({ day: getDayOfMonth(d), month: getMonth(d), year: getYear(d) });
    }
  }
  componentWillReceiveProps(newProps: Props){
    if(newProps.date){
      if (!this.state.date || !isSame(newProps.date, this.state.date)){
        let d = newProps.date;
        this.setState({ day: getDayOfMonth(d), month: getMonth(d), year: getYear(d), date: newProps.date })
      }
    }else{
        this.setState({ day: null, month: null, year: null, date: null })
    }
  }
  buildDate() {
    let d = this.createDate();
    this.setState({ date: d }, () => {
      if (this.props.onChange && d) {
        this.props.onChange(this.state.date);
      }
    })
  }
  createDate(): IDate {
    let s = this.state;
    let d;
    if (s.day && s.month && s.year) {
      d = createDateFromParts(s.day, s.month, s.year);
    }

    /*
     * the most common cause of an invalid date is an out of range day (31st Feb for example)
     * if this is the case, return the 1st of the month being changed to
    */
    if (d && d.value === "Invalid date") {
      d = createDateFromParts(1, s.month, s.year);
      this.dayChanged("1");
    }

    return d;
  }
  render() {
    let dayOptions = [<option key="ds-label" value="" disabled={true}>Day</option>];
    this.getDaysArrayByMonth().forEach(d => {
      dayOptions.push(<option key={`ds-${d}`} value={d}>{parseInt(d) < 10 ? `0${d}` : d.toString() }</option>);
    })

    let monthOptions = [<option key="ms-label" value="" disabled={true}>Month</option>];
    for (var i = 0; i < 12; i++) {
      var month = moment().month(i)
      monthOptions.push(<option key={`ms-${month.format("M")}`} value={month.format("M")}>{month.format("MMMM") }</option>);
    }

    let yearOptions = [<option key="ys-label" value="" disabled={true}>Year</option>];
    for (var i = 0; i < (this.props.yearsFromNow || 110); i++) {
      var year = this.props.futureDates ? moment().add(i, 'years').year() : moment().subtract(i, 'years').year();
      yearOptions.push(<option key={`ys-${year}`} value={year.toString()}>{year}</option>);
    }

    return <Grid>
      <Row>
        <Col>
          <select onChange={(e) => this.dayChanged(e.target.value)} value={this.state.day ? this.state.day.toString() : ""}>
            {dayOptions}
          </select>
        </Col>
        <Col>
          <select onChange={(e) => this.monthChanged(e.target.value)} value={this.state.month ? this.state.month.toString() : ""}>
            {monthOptions}
          </select>
        </Col>
        <Col>
          <select onChange={(e) => this.yearChanged(e.target.value)} value={this.state.year ? this.state.year.toString() : ""}>
            {yearOptions}
          </select>
        </Col>
      </Row>
    </Grid>
  }
}